/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AggregateLevel = "DAY" | "MONTH" | "YEAR" | "%future added value";
export type FinancialAggregatedNumber = "accruedDeferred" | "actualCost" | "actualLockedRevenue" | "actualMargin" | "actualOpenRevenue" | "actualProfit" | "actualRevenue" | "actualRevenueMargin" | "actualRevenueProfit" | "allActualTimeAndExpenses" | "allForecastTimeAndExpensesToComplete" | "allPlannedTimeAndExpenses" | "allTotalTimeAndExpensesAtCompletion" | "allocationMinutes" | "baselineCost" | "baselineMargin" | "baselineMinutes" | "baselineProfit" | "baselineRevenue" | "baselineTimeAndExpenses" | "baselineVsActualCost" | "baselineVsActualMargin" | "baselineVsActualProfit" | "baselineVsActualRevenue" | "baselineVsActualRevenueMargin" | "baselineVsActualRevenueProfit" | "baselineVsActualRevenueRecognition" | "baselineVsBillableActualTimeAndExpenses" | "baselineVsBillableTotalTimeAndExpensesAtCompletion" | "baselineVsForecastCost" | "baselineVsForecastMinutes" | "baselineVsForecastProfit" | "baselineVsForecastRevenue" | "baselineVsRegisteredMinutes" | "baselineVsTotalCostAtCompletion" | "baselineVsTotalMarginAtCompletion" | "baselineVsTotalProfitAtCompletion" | "baselineVsTotalRevenueAtCompletion" | "baselineVsTotalRevenueMarginAtCompletion" | "baselineVsTotalRevenueProfitAtCompletion" | "baselineVsTotalTimeAtCompletion" | "billableActualMinutes" | "billableActualTimeAndExpenses" | "billableForecastTimeAndExpensesToComplete" | "billablePlannedTimeAndExpenses" | "billableTime" | "billableTotalTimeAndExpensesAtCompletion" | "estimatedCost" | "estimatedCostPercentage" | "expenseCostPercentage" | "expenseRevenuePercentage" | "forecastCost" | "forecastCostToComplete" | "forecastLockedRevenueToComplete" | "forecastMargin" | "forecastMarginToComplete" | "forecastMinutes" | "forecastOpenRevenueToComplete" | "forecastProfit" | "forecastProfitToComplete" | "forecastRevenue" | "forecastRevenueMarginToComplete" | "forecastRevenueProfitToComplete" | "forecastTimeToComplete" | "forecastVsScopeApprovedMinutes" | "invoiced" | "nonBillableActualMinutes" | "nonBillableActualTimeAndExpenses" | "nonBillableForecastTimeAndExpensesToComplete" | "nonBillablePlannedTimeAndExpenses" | "nonBillableTotalTimeAndExpensesAtCompletion" | "paid" | "planVsActualCost" | "planVsActualMargin" | "planVsActualProfit" | "planVsActualRevenue" | "planVsActualRevenueMargin" | "planVsActualRevenueProfit" | "planVsActualRevenueRecognition" | "planVsBillableActualTimeAndExpenses" | "planVsForecastCost" | "planVsForecastProfit" | "planVsForecastRevenue" | "planVsTotalBillableTimeAndExpensesAtCompletion" | "planVsTotalCostAtCompletion" | "planVsTotalMarginAtCompletion" | "planVsTotalProfitAtCompletion" | "planVsTotalRevenueAtCompletion" | "planVsTotalRevenueMarginAtCompletion" | "planVsTotalRevenueProfitAtCompletion" | "plannedCost" | "plannedMargin" | "plannedProfit" | "plannedRevenue" | "plannedRevenueMargin" | "plannedRevenueProfit" | "projectedTotalRevenueVsProjectedTotalBillableValueOfService" | "projectedTotalRevenueVsProjectedTotalValueOfService" | "recognitionActualProfit" | "recognitionActualProfitPercentage" | "recognitionAmount" | "recognitionForecastRevenue" | "recognitionLockedProfit" | "recognitionLockedProfitPercentage" | "recognitionLockedRevenue" | "recognitionOpenRevenue" | "recognitionPercentage" | "recognitionProfit" | "recognitionProfitPercentage" | "registeredMinutes" | "registeredVsScopeApprovedMinutes" | "remainingCost" | "remainingMargin" | "remainingMinutes" | "remainingProfit" | "remainingRevenue" | "retainerPeriodRolloverMinutes" | "retainerPeriodRolloverPrice" | "retainerPeriodTargetMinutes" | "retainerPeriodTargetPrice" | "scopeApprovedMinutes" | "scopeApprovedVsForecastMinutes" | "scopeApprovedVsRegisteredMinutes" | "scopeApprovedVsTotalTimeAtCompletion" | "scopeTotalMinutes" | "suggestedProfit" | "suggestedProfitPercentage" | "suggestedRevenue" | "suggestedRevenuePercentage" | "surplus" | "surplusPercentage" | "totalActualRevenueRecognition" | "totalCostAtCompletion" | "totalForecastRevenueToComplete" | "totalMarginAtCompletion" | "totalProfitAtCompletion" | "totalRevenueMarginAtCompletion" | "totalRevenueProfitAtCompletion" | "totalRevenueRecognition" | "totalTimeAtCompletion" | "totalTimeAtCompletionVsScopeApprovedMinutes" | "%future added value";
export type GLOBAL_FILTER_CONTEXT = "INVOICES" | "LABELS" | "PEOPLE" | "PLACEHOLDERS" | "PROJECTS" | "RESOURCES" | "SKILLS" | "TASKS" | "TIME_REGS" | "%future added value";
export type GLOBAL_FILTER_FIELD = "APPROVAL_STATUS" | "ASSIGNED" | "ASSIGNED_SELF" | "BILLABLE" | "BILLABLE_TIME_REG" | "BILL_FROM" | "BILL_TO" | "BLOCKED" | "BUG" | "CLIENT" | "CLIENT_GUEST_USERS" | "CLIENT_TIME_REG" | "COMPANY_TASK_ID" | "CONTACT" | "CREATED_AT" | "DEADLINE" | "DEPARTMENT" | "DEPARTMENT_TIME_REG" | "DEPENDENCIES" | "DESCRIPTION" | "END_DATE" | "END_DATE_PROJECT" | "END_DATE_TIME_REG" | "FILTER_BY_TIME_REG_SETTINGS" | "FOLLOWER" | "FORECAST" | "HIGH_PRIORITY" | "INTERNAL_TIME" | "INTERNAL_TIME_REG" | "INVOICED" | "LABELS" | "LABEL_TIME_REG" | "NAME" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "NON_TASK_TIME_REG" | "NO_CONTACT" | "OWNER" | "PERMISSION_LEVEL" | "PERSON" | "PERSON_TIME_REG" | "PHASE_CATEGORY" | "PHASE_TIME_REG" | "PRIORITY_LEVEL" | "PROGRAM" | "PROJECT" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "PROJECT_FOLLOWER" | "PROJECT_GROUP" | "PROJECT_GROUP_SPRINT" | "PROJECT_GROUP_STATUS" | "PROJECT_LABELS" | "PROJECT_MANUAL_PROGRESS" | "PROJECT_OWNER" | "PROJECT_PERSON" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_STAGE" | "PROJECT_STATUS" | "PROJECT_TIME_REG" | "PROJECT_WIN_CHANCE" | "RATE_CARD" | "RECENT_ACTIVITY" | "RECENT_TASK_ACTIVITY" | "RECENT_TIME" | "REMAINING" | "RETAINER_PERIOD" | "ROLE" | "ROLE_TIME_REG" | "SET_DONE_AT" | "SKILL" | "SPRINT_CATEGORY" | "SPRINT_TIME_REG" | "STARRED" | "START_DATE" | "START_DATE_PROJECT" | "START_DATE_TIME_REG" | "STATUS" | "SUB_TASKS" | "TASK" | "TASK_APPROVED" | "TASK_HIERARCHY" | "TASK_LEVEL" | "TASK_TIME_REG" | "TEAM" | "TEAM_MEMBER" | "TEAM_TIME_REG" | "TIME_OFF" | "TIME_OFF_TIME_REG" | "TIME_REGS" | "UPDATED_AT" | "WITH_TASKS" | "WITH_TIME_REG" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "ALL_IN" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "IN" | "IS" | "IS_ALL" | "IS_NOT" | "IS_NOT_ALL" | "LESS" | "LESS_OR_EQUAL" | "NOT_ALL_IN" | "NOT_IN" | "%future added value";
export type TaskSearchQueryType = {
    filters?: Array<GlobalSearchFilterType | null> | null | undefined;
};
export type GlobalSearchFilterType = {
    field?: GLOBAL_FILTER_FIELD | null | undefined;
    operator?: GLOBAL_FILTER_OPERATOR | null | undefined;
    value?: Array<string | null> | null | undefined;
    context?: GLOBAL_FILTER_CONTEXT | null | undefined;
    filters?: Array<GlobalSearchFilterType | null> | null | undefined;
    logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null | undefined;
};
export type DetailsExpenseCategoryLoader_QueryVariables = {
    projectId: string;
    phaseId: string;
    startYear: number;
    startMonth: number;
    startDay: number;
    endYear: number;
    endMonth: number;
    endDay: number;
    aggregateLevel: AggregateLevel;
    aggregate: FinancialAggregatedNumber;
    searchQuery?: TaskSearchQueryType | null | undefined;
    baselineRevenue: boolean;
    baselineCost: boolean;
    baselineProfit: boolean;
    billableActualTimeAndExpenses: boolean;
    actualCost: boolean;
    actualProfit: boolean;
    billablePlannedTimeAndExpenses: boolean;
    plannedCost: boolean;
    plannedProfit: boolean;
    billableForecastTimeAndExpensesToComplete: boolean;
    forecastCostToComplete: boolean;
    forecastProfitToComplete: boolean;
    billableTotalTimeAndExpensesAtCompletion: boolean;
    totalCostAtCompletion: boolean;
    totalProfitAtCompletion: boolean;
    planVsBillableActualTimeAndExpenses: boolean;
    planVsActualCost: boolean;
    planVsActualProfit: boolean;
    planVsTotalBillableTimeAndExpensesAtCompletion: boolean;
    planVsTotalCostAtCompletion: boolean;
    planVsTotalProfitAtCompletion: boolean;
    baselineVsBillableActualTimeAndExpenses: boolean;
    baselineVsActualCost: boolean;
    baselineVsActualProfit: boolean;
    baselineVsBillableTotalTimeAndExpensesAtCompletion: boolean;
    baselineVsTotalCostAtCompletion: boolean;
    baselineVsTotalProfitAtCompletion: boolean;
    invoiced: boolean;
    paid: boolean;
    baselineMinutes: boolean;
    baselineVsRegisteredMinutes: boolean;
    baselineVsTotalTimeAtCompletion: boolean;
    registeredMinutes: boolean;
    scopeApprovedMinutes: boolean;
    registeredVsScopeApprovedMinutes: boolean;
    scopeApprovedVsRegisteredMinutes: boolean;
    forecastTimeToComplete: boolean;
    totalTimeAtCompletion: boolean;
    totalTimeAtCompletionVsScopeApprovedMinutes: boolean;
    scopeApprovedVsTotalTimeAtCompletion: boolean;
};
export type DetailsExpenseCategoryLoader_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"DetailsExpenseCategoryLoader_viewer">;
    } | null;
};
export type DetailsExpenseCategoryLoader_Query = {
    readonly response: DetailsExpenseCategoryLoader_QueryResponse;
    readonly variables: DetailsExpenseCategoryLoader_QueryVariables;
};



/*
query DetailsExpenseCategoryLoader_Query(
  $projectId: ID!
  $phaseId: ID!
  $startYear: Int!
  $startMonth: Int!
  $startDay: Int!
  $endYear: Int!
  $endMonth: Int!
  $endDay: Int!
  $aggregateLevel: AggregateLevel!
  $aggregate: FinancialAggregatedNumber!
  $searchQuery: TaskSearchQueryType
  $baselineRevenue: Boolean!
  $baselineCost: Boolean!
  $baselineProfit: Boolean!
  $billableActualTimeAndExpenses: Boolean!
  $actualCost: Boolean!
  $actualProfit: Boolean!
  $billablePlannedTimeAndExpenses: Boolean!
  $plannedCost: Boolean!
  $plannedProfit: Boolean!
  $billableForecastTimeAndExpensesToComplete: Boolean!
  $forecastCostToComplete: Boolean!
  $forecastProfitToComplete: Boolean!
  $billableTotalTimeAndExpensesAtCompletion: Boolean!
  $totalCostAtCompletion: Boolean!
  $totalProfitAtCompletion: Boolean!
  $planVsBillableActualTimeAndExpenses: Boolean!
  $planVsActualCost: Boolean!
  $planVsActualProfit: Boolean!
  $planVsTotalBillableTimeAndExpensesAtCompletion: Boolean!
  $planVsTotalCostAtCompletion: Boolean!
  $planVsTotalProfitAtCompletion: Boolean!
  $baselineVsBillableActualTimeAndExpenses: Boolean!
  $baselineVsActualCost: Boolean!
  $baselineVsActualProfit: Boolean!
  $baselineVsBillableTotalTimeAndExpensesAtCompletion: Boolean!
  $baselineVsTotalCostAtCompletion: Boolean!
  $baselineVsTotalProfitAtCompletion: Boolean!
  $invoiced: Boolean!
  $paid: Boolean!
  $baselineMinutes: Boolean!
  $baselineVsRegisteredMinutes: Boolean!
  $baselineVsTotalTimeAtCompletion: Boolean!
  $registeredMinutes: Boolean!
  $scopeApprovedMinutes: Boolean!
  $registeredVsScopeApprovedMinutes: Boolean!
  $scopeApprovedVsRegisteredMinutes: Boolean!
  $forecastTimeToComplete: Boolean!
  $totalTimeAtCompletion: Boolean!
  $totalTimeAtCompletionVsScopeApprovedMinutes: Boolean!
  $scopeApprovedVsTotalTimeAtCompletion: Boolean!
) {
  viewer {
    actualPersonId
    component(name: "details_expense_loader")
    ...DetailsExpenseCategoryLoader_viewer_4v8vw5
    id
  }
}

fragment DetailsExpenseCategoryLoader_viewer_4v8vw5 on Viewer {
  id
  company {
    currency
    id
  }
  project(internalId: $projectId) {
    rateCard {
      currency
      id
    }
    expenseCategoryFinancialBreakdown(phaseId: $phaseId, searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true, filterRowsWithNoValues: true) {
      breakdownType
      expenseCategory {
        id
        name
      }
      financialNumbers {
        baselineRevenue @include(if: $baselineRevenue)
        baselineCost @include(if: $baselineCost)
        baselineProfit @include(if: $baselineProfit)
        billableActualTimeAndExpenses @include(if: $billableActualTimeAndExpenses)
        actualCost @include(if: $actualCost)
        actualProfit @include(if: $actualProfit)
        billablePlannedTimeAndExpenses @include(if: $billablePlannedTimeAndExpenses)
        plannedCost @include(if: $plannedCost)
        plannedProfit @include(if: $plannedProfit)
        billableForecastTimeAndExpensesToComplete @include(if: $billableForecastTimeAndExpensesToComplete)
        forecastCostToComplete @include(if: $forecastCostToComplete)
        forecastProfitToComplete @include(if: $forecastProfitToComplete)
        billableTotalTimeAndExpensesAtCompletion @include(if: $billableTotalTimeAndExpensesAtCompletion)
        totalCostAtCompletion @include(if: $totalCostAtCompletion)
        totalProfitAtCompletion @include(if: $totalProfitAtCompletion)
        planVsBillableActualTimeAndExpenses @include(if: $planVsBillableActualTimeAndExpenses)
        planVsActualCost @include(if: $planVsActualCost)
        planVsActualProfit @include(if: $planVsActualProfit)
        planVsTotalBillableTimeAndExpensesAtCompletion @include(if: $planVsTotalBillableTimeAndExpensesAtCompletion)
        planVsTotalCostAtCompletion @include(if: $planVsTotalCostAtCompletion)
        planVsTotalProfitAtCompletion @include(if: $planVsTotalProfitAtCompletion)
        baselineVsBillableActualTimeAndExpenses @include(if: $baselineVsBillableActualTimeAndExpenses)
        baselineVsActualCost @include(if: $baselineVsActualCost)
        baselineVsActualProfit @include(if: $baselineVsActualProfit)
        baselineVsBillableTotalTimeAndExpensesAtCompletion @include(if: $baselineVsBillableTotalTimeAndExpensesAtCompletion)
        baselineVsTotalCostAtCompletion @include(if: $baselineVsTotalCostAtCompletion)
        baselineVsTotalProfitAtCompletion @include(if: $baselineVsTotalProfitAtCompletion)
        invoiced @include(if: $invoiced)
        paid @include(if: $paid)
        baselineMinutes @include(if: $baselineMinutes)
        baselineVsRegisteredMinutes @include(if: $baselineVsRegisteredMinutes)
        baselineVsTotalTimeAtCompletion @include(if: $baselineVsTotalTimeAtCompletion)
        registeredMinutes @include(if: $registeredMinutes)
        scopeApprovedMinutes @include(if: $scopeApprovedMinutes)
        registeredVsScopeApprovedMinutes @include(if: $registeredVsScopeApprovedMinutes)
        scopeApprovedVsRegisteredMinutes @include(if: $scopeApprovedVsRegisteredMinutes)
        forecastTimeToComplete @include(if: $forecastTimeToComplete)
        totalTimeAtCompletion @include(if: $totalTimeAtCompletion)
        totalTimeAtCompletionVsScopeApprovedMinutes @include(if: $totalTimeAtCompletionVsScopeApprovedMinutes)
        scopeApprovedVsTotalTimeAtCompletion @include(if: $scopeApprovedVsTotalTimeAtCompletion)
      }
    }
    aggregatedExpenseCategoryFinancialBreakdown(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, phaseId: $phaseId, aggregateLevel: $aggregateLevel, aggregates: [$aggregate], searchQuery: $searchQuery, convertToProjectCurrency: true, filterRowsWithNoValues: true) {
      breakdownType
      expenseCategory {
        id
        name
      }
      aggregatedFinancialNumbers
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "phaseId",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startYear",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startMonth",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDay",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endYear",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endMonth",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endDay",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aggregateLevel",
    "type": "AggregateLevel!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aggregate",
    "type": "FinancialAggregatedNumber!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchQuery",
    "type": "TaskSearchQueryType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineRevenue",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineCost",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineProfit",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "billableActualTimeAndExpenses",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "actualCost",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "actualProfit",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "billablePlannedTimeAndExpenses",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "plannedCost",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "plannedProfit",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "billableForecastTimeAndExpensesToComplete",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "forecastCostToComplete",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "forecastProfitToComplete",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "billableTotalTimeAndExpensesAtCompletion",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "totalCostAtCompletion",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "totalProfitAtCompletion",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planVsBillableActualTimeAndExpenses",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planVsActualCost",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planVsActualProfit",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planVsTotalCostAtCompletion",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planVsTotalProfitAtCompletion",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineVsBillableActualTimeAndExpenses",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineVsActualCost",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineVsActualProfit",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineVsTotalCostAtCompletion",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineVsTotalProfitAtCompletion",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "invoiced",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "paid",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineMinutes",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineVsRegisteredMinutes",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "baselineVsTotalTimeAtCompletion",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "registeredMinutes",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scopeApprovedMinutes",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "registeredVsScopeApprovedMinutes",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scopeApprovedVsRegisteredMinutes",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "forecastTimeToComplete",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "totalTimeAtCompletion",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "totalTimeAtCompletionVsScopeApprovedMinutes",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scopeApprovedVsTotalTimeAtCompletion",
    "type": "Boolean!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "details_expense_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"details_expense_loader\")"
},
v3 = {
  "kind": "Variable",
  "name": "aggregateLevel",
  "variableName": "aggregateLevel"
},
v4 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v5 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v6 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v7 = {
  "kind": "Variable",
  "name": "phaseId",
  "variableName": "phaseId"
},
v8 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v9 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v10 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v11 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  (v12/*: any*/)
],
v14 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v15 = {
  "kind": "Literal",
  "name": "filterRowsWithNoValues",
  "value": true
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breakdownType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseCategory",
  "kind": "LinkedField",
  "name": "expenseCategory",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DetailsExpenseCategoryLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "actualCost",
                "variableName": "actualCost"
              },
              {
                "kind": "Variable",
                "name": "actualProfit",
                "variableName": "actualProfit"
              },
              {
                "kind": "Variable",
                "name": "aggregate",
                "variableName": "aggregate"
              },
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "baselineCost",
                "variableName": "baselineCost"
              },
              {
                "kind": "Variable",
                "name": "baselineMinutes",
                "variableName": "baselineMinutes"
              },
              {
                "kind": "Variable",
                "name": "baselineProfit",
                "variableName": "baselineProfit"
              },
              {
                "kind": "Variable",
                "name": "baselineRevenue",
                "variableName": "baselineRevenue"
              },
              {
                "kind": "Variable",
                "name": "baselineVsActualCost",
                "variableName": "baselineVsActualCost"
              },
              {
                "kind": "Variable",
                "name": "baselineVsActualProfit",
                "variableName": "baselineVsActualProfit"
              },
              {
                "kind": "Variable",
                "name": "baselineVsBillableActualTimeAndExpenses",
                "variableName": "baselineVsBillableActualTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                "variableName": "baselineVsBillableTotalTimeAndExpensesAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsRegisteredMinutes",
                "variableName": "baselineVsRegisteredMinutes"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalCostAtCompletion",
                "variableName": "baselineVsTotalCostAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalProfitAtCompletion",
                "variableName": "baselineVsTotalProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalTimeAtCompletion",
                "variableName": "baselineVsTotalTimeAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "billableActualTimeAndExpenses",
                "variableName": "billableActualTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "billableForecastTimeAndExpensesToComplete",
                "variableName": "billableForecastTimeAndExpensesToComplete"
              },
              {
                "kind": "Variable",
                "name": "billablePlannedTimeAndExpenses",
                "variableName": "billablePlannedTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "billableTotalTimeAndExpensesAtCompletion",
                "variableName": "billableTotalTimeAndExpensesAtCompletion"
              },
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "Variable",
                "name": "forecastCostToComplete",
                "variableName": "forecastCostToComplete"
              },
              {
                "kind": "Variable",
                "name": "forecastProfitToComplete",
                "variableName": "forecastProfitToComplete"
              },
              {
                "kind": "Variable",
                "name": "forecastTimeToComplete",
                "variableName": "forecastTimeToComplete"
              },
              {
                "kind": "Variable",
                "name": "invoiced",
                "variableName": "invoiced"
              },
              {
                "kind": "Variable",
                "name": "paid",
                "variableName": "paid"
              },
              (v7/*: any*/),
              {
                "kind": "Variable",
                "name": "planVsActualCost",
                "variableName": "planVsActualCost"
              },
              {
                "kind": "Variable",
                "name": "planVsActualProfit",
                "variableName": "planVsActualProfit"
              },
              {
                "kind": "Variable",
                "name": "planVsBillableActualTimeAndExpenses",
                "variableName": "planVsBillableActualTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
                "variableName": "planVsTotalBillableTimeAndExpensesAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalCostAtCompletion",
                "variableName": "planVsTotalCostAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalProfitAtCompletion",
                "variableName": "planVsTotalProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "plannedCost",
                "variableName": "plannedCost"
              },
              {
                "kind": "Variable",
                "name": "plannedProfit",
                "variableName": "plannedProfit"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              {
                "kind": "Variable",
                "name": "registeredMinutes",
                "variableName": "registeredMinutes"
              },
              {
                "kind": "Variable",
                "name": "registeredVsScopeApprovedMinutes",
                "variableName": "registeredVsScopeApprovedMinutes"
              },
              {
                "kind": "Variable",
                "name": "scopeApprovedMinutes",
                "variableName": "scopeApprovedMinutes"
              },
              {
                "kind": "Variable",
                "name": "scopeApprovedVsRegisteredMinutes",
                "variableName": "scopeApprovedVsRegisteredMinutes"
              },
              {
                "kind": "Variable",
                "name": "scopeApprovedVsTotalTimeAtCompletion",
                "variableName": "scopeApprovedVsTotalTimeAtCompletion"
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "kind": "Variable",
                "name": "totalCostAtCompletion",
                "variableName": "totalCostAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "totalProfitAtCompletion",
                "variableName": "totalProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "totalTimeAtCompletion",
                "variableName": "totalTimeAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "totalTimeAtCompletionVsScopeApprovedMinutes",
                "variableName": "totalTimeAtCompletionVsScopeApprovedMinutes"
              }
            ],
            "kind": "FragmentSpread",
            "name": "DetailsExpenseCategoryLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DetailsExpenseCategoryLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "internalId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v14/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v15/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "concreteType": "ExpenseCategoryFinancialBreakdown",
                "kind": "LinkedField",
                "name": "expenseCategoryFinancialBreakdown",
                "plural": true,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinancialNumbers",
                    "kind": "LinkedField",
                    "name": "financialNumbers",
                    "plural": false,
                    "selections": [
                      {
                        "condition": "baselineRevenue",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineRevenue",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billableActualTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billableActualTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "actualCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actualCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "actualProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actualProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billablePlannedTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billablePlannedTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "plannedCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "plannedCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "plannedProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "plannedProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billableForecastTimeAndExpensesToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billableForecastTimeAndExpensesToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "forecastCostToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecastCostToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "forecastProfitToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecastProfitToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billableTotalTimeAndExpensesAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billableTotalTimeAndExpensesAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalCostAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalCostAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsBillableActualTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsBillableActualTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsActualCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsActualCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsActualProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsActualProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalBillableTimeAndExpensesAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalCostAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalCostAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsBillableActualTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsBillableActualTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsActualCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsActualCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsActualProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsActualProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalCostAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalCostAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "invoiced",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "invoiced",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "paid",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "paid",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsRegisteredMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsRegisteredMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalTimeAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalTimeAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "registeredMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "registeredMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "scopeApprovedMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scopeApprovedMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "registeredVsScopeApprovedMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "registeredVsScopeApprovedMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "scopeApprovedVsRegisteredMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scopeApprovedVsRegisteredMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "forecastTimeToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecastTimeToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalTimeAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTimeAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalTimeAtCompletionVsScopeApprovedMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTimeAtCompletionVsScopeApprovedMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "scopeApprovedVsTotalTimeAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scopeApprovedVsTotalTimeAtCompletion",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v3/*: any*/),
                  {
                    "items": [
                      {
                        "kind": "Variable",
                        "name": "aggregates.0",
                        "variableName": "aggregate"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "aggregates"
                  },
                  (v14/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v15/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "concreteType": "AggregatedExpenseCategoryFinancialBreakdown",
                "kind": "LinkedField",
                "name": "aggregatedExpenseCategoryFinancialBreakdown",
                "plural": true,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aggregatedFinancialNumbers",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DetailsExpenseCategoryLoader_Query",
    "operationKind": "query",
    "text": "query DetailsExpenseCategoryLoader_Query(\n  $projectId: ID!\n  $phaseId: ID!\n  $startYear: Int!\n  $startMonth: Int!\n  $startDay: Int!\n  $endYear: Int!\n  $endMonth: Int!\n  $endDay: Int!\n  $aggregateLevel: AggregateLevel!\n  $aggregate: FinancialAggregatedNumber!\n  $searchQuery: TaskSearchQueryType\n  $baselineRevenue: Boolean!\n  $baselineCost: Boolean!\n  $baselineProfit: Boolean!\n  $billableActualTimeAndExpenses: Boolean!\n  $actualCost: Boolean!\n  $actualProfit: Boolean!\n  $billablePlannedTimeAndExpenses: Boolean!\n  $plannedCost: Boolean!\n  $plannedProfit: Boolean!\n  $billableForecastTimeAndExpensesToComplete: Boolean!\n  $forecastCostToComplete: Boolean!\n  $forecastProfitToComplete: Boolean!\n  $billableTotalTimeAndExpensesAtCompletion: Boolean!\n  $totalCostAtCompletion: Boolean!\n  $totalProfitAtCompletion: Boolean!\n  $planVsBillableActualTimeAndExpenses: Boolean!\n  $planVsActualCost: Boolean!\n  $planVsActualProfit: Boolean!\n  $planVsTotalBillableTimeAndExpensesAtCompletion: Boolean!\n  $planVsTotalCostAtCompletion: Boolean!\n  $planVsTotalProfitAtCompletion: Boolean!\n  $baselineVsBillableActualTimeAndExpenses: Boolean!\n  $baselineVsActualCost: Boolean!\n  $baselineVsActualProfit: Boolean!\n  $baselineVsBillableTotalTimeAndExpensesAtCompletion: Boolean!\n  $baselineVsTotalCostAtCompletion: Boolean!\n  $baselineVsTotalProfitAtCompletion: Boolean!\n  $invoiced: Boolean!\n  $paid: Boolean!\n  $baselineMinutes: Boolean!\n  $baselineVsRegisteredMinutes: Boolean!\n  $baselineVsTotalTimeAtCompletion: Boolean!\n  $registeredMinutes: Boolean!\n  $scopeApprovedMinutes: Boolean!\n  $registeredVsScopeApprovedMinutes: Boolean!\n  $scopeApprovedVsRegisteredMinutes: Boolean!\n  $forecastTimeToComplete: Boolean!\n  $totalTimeAtCompletion: Boolean!\n  $totalTimeAtCompletionVsScopeApprovedMinutes: Boolean!\n  $scopeApprovedVsTotalTimeAtCompletion: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"details_expense_loader\")\n    ...DetailsExpenseCategoryLoader_viewer_4v8vw5\n    id\n  }\n}\n\nfragment DetailsExpenseCategoryLoader_viewer_4v8vw5 on Viewer {\n  id\n  company {\n    currency\n    id\n  }\n  project(internalId: $projectId) {\n    rateCard {\n      currency\n      id\n    }\n    expenseCategoryFinancialBreakdown(phaseId: $phaseId, searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true, filterRowsWithNoValues: true) {\n      breakdownType\n      expenseCategory {\n        id\n        name\n      }\n      financialNumbers {\n        baselineRevenue @include(if: $baselineRevenue)\n        baselineCost @include(if: $baselineCost)\n        baselineProfit @include(if: $baselineProfit)\n        billableActualTimeAndExpenses @include(if: $billableActualTimeAndExpenses)\n        actualCost @include(if: $actualCost)\n        actualProfit @include(if: $actualProfit)\n        billablePlannedTimeAndExpenses @include(if: $billablePlannedTimeAndExpenses)\n        plannedCost @include(if: $plannedCost)\n        plannedProfit @include(if: $plannedProfit)\n        billableForecastTimeAndExpensesToComplete @include(if: $billableForecastTimeAndExpensesToComplete)\n        forecastCostToComplete @include(if: $forecastCostToComplete)\n        forecastProfitToComplete @include(if: $forecastProfitToComplete)\n        billableTotalTimeAndExpensesAtCompletion @include(if: $billableTotalTimeAndExpensesAtCompletion)\n        totalCostAtCompletion @include(if: $totalCostAtCompletion)\n        totalProfitAtCompletion @include(if: $totalProfitAtCompletion)\n        planVsBillableActualTimeAndExpenses @include(if: $planVsBillableActualTimeAndExpenses)\n        planVsActualCost @include(if: $planVsActualCost)\n        planVsActualProfit @include(if: $planVsActualProfit)\n        planVsTotalBillableTimeAndExpensesAtCompletion @include(if: $planVsTotalBillableTimeAndExpensesAtCompletion)\n        planVsTotalCostAtCompletion @include(if: $planVsTotalCostAtCompletion)\n        planVsTotalProfitAtCompletion @include(if: $planVsTotalProfitAtCompletion)\n        baselineVsBillableActualTimeAndExpenses @include(if: $baselineVsBillableActualTimeAndExpenses)\n        baselineVsActualCost @include(if: $baselineVsActualCost)\n        baselineVsActualProfit @include(if: $baselineVsActualProfit)\n        baselineVsBillableTotalTimeAndExpensesAtCompletion @include(if: $baselineVsBillableTotalTimeAndExpensesAtCompletion)\n        baselineVsTotalCostAtCompletion @include(if: $baselineVsTotalCostAtCompletion)\n        baselineVsTotalProfitAtCompletion @include(if: $baselineVsTotalProfitAtCompletion)\n        invoiced @include(if: $invoiced)\n        paid @include(if: $paid)\n        baselineMinutes @include(if: $baselineMinutes)\n        baselineVsRegisteredMinutes @include(if: $baselineVsRegisteredMinutes)\n        baselineVsTotalTimeAtCompletion @include(if: $baselineVsTotalTimeAtCompletion)\n        registeredMinutes @include(if: $registeredMinutes)\n        scopeApprovedMinutes @include(if: $scopeApprovedMinutes)\n        registeredVsScopeApprovedMinutes @include(if: $registeredVsScopeApprovedMinutes)\n        scopeApprovedVsRegisteredMinutes @include(if: $scopeApprovedVsRegisteredMinutes)\n        forecastTimeToComplete @include(if: $forecastTimeToComplete)\n        totalTimeAtCompletion @include(if: $totalTimeAtCompletion)\n        totalTimeAtCompletionVsScopeApprovedMinutes @include(if: $totalTimeAtCompletionVsScopeApprovedMinutes)\n        scopeApprovedVsTotalTimeAtCompletion @include(if: $scopeApprovedVsTotalTimeAtCompletion)\n      }\n    }\n    aggregatedExpenseCategoryFinancialBreakdown(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, phaseId: $phaseId, aggregateLevel: $aggregateLevel, aggregates: [$aggregate], searchQuery: $searchQuery, convertToProjectCurrency: true, filterRowsWithNoValues: true) {\n      breakdownType\n      expenseCategory {\n        id\n        name\n      }\n      aggregatedFinancialNumbers\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '3827742e3ada7a3f6dcd8b5968afdaae';
export default node;
